<div class="location-info-text">
  <div class="location-name">
    {{ location?.name }}
    <span *ngIf="location | locationMarkedAsRequired: requiredLocationIds" class="asterisk">*</span>
  </div>
  <div class="location-address">{{ location?.address }}</div>
  <div class="location-city">{{ location?.city }}</div>
</div>
